import { render } from "./News.vue?vue&type=template&id=95318cec&scoped=true"
import script from "./News.vue?vue&type=script&lang=js"
export * from "./News.vue?vue&type=script&lang=js"

import "./News.vue?vue&type=style&index=0&id=95318cec&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-95318cec"

export default script